const sanitizeCorrectionsReducer = (
    accum,
    correction,
    referenceCorrections
) => {
    if (correction.isCreated)
        return [
            ...accum,
            {
                name: correction.label,
                slope: correction.slope,
                bias: correction.bias,
                isCreated: correction.isCreated,
            },
        ];
    else if (!referenceCorrections[correction.value] || correction.isDeleted) {
        return [
            ...accum,
            {
                scannerId: correction.value,
                slope: correction.slope,
                bias: correction.bias,
                isDeleted: correction.isDeleted,
            },
        ];
    }
    return [
        ...accum,
        {
            scannerId: correction.value,
            slope: correction.slope,
            bias: correction.bias,
        },
    ];
};

const getCorrectionChanges = (addedCorrections, referenceCorrections) => {
    return addedCorrections.reduce(
        (accum, correction) =>
            sanitizeCorrectionsReducer(accum, correction, referenceCorrections),
        []
    );
};

export { getCorrectionChanges };
